<div class="chart-wrap">
  <div id="chart" class="donut-chart fw fh" [ngClass]="{'chart-hidden' : total===0}"></div>
  @if (total!==0) {
    <div class="donut-text-field">
      <div class="number-field">
        <span>{{total}}</span>
      </div>
      <div class="text-field">
        @if (classification==='totalparam') {
          <span class="criticality-label dashboard-font-header">{{'common.total'
          | translate}}</span>
        }
        @if (classification==='aa') {
          <span class="criticality-label-AA dashboard-font-header"> {{'common.aa' |
          translate}} </span>
        }
        @if (classification==='a') {
          <span class="criticality-label-A" dashboard-font-header>{{'common.a' |
          translate}}</span>
        }
        @if (classification==='b') {
          <span class="criticality-label-B" dashboard-font-header>{{'common.b' |
          translate}}</span>
        }
        @if (classification==='c') {
          <span class="criticality-label-C" dashboard-font-header>{{'common.c' |
          translate}}</span>
        }
        @if (total===1) {
          <span class="param-text dashboard-font-header">{{'common.parameter' | translate}}</span>
        }
        @if (total>1) {
          <span class="param-text dashboard-font-header">{{'common.parameters' | translate}}</span>
        }
      </div>
    </div>
  }
  @if (total===0) {
    <div class="donut-text-field" [ngClass]="{'no-data-text': total === 0}">
      <div class="text-field">
        <span class="param-text">{{'common.no_data_small' | translate}}</span>
      </div>
    </div>
  }
</div>